import { prop } from "ramda";
import { getNonRevenueWater } from "../../services/apis";
import { isServerResponseError, hasError } from "../common";

const getNonRevenueWaterData = async (filter) => {
  const result = await getNonRevenueWater({
    ...filter,
  });
  return isServerResponseError(result) || hasError(result)
    ? {
        data: [],
      }
    : prop("data", result);
};

export default getNonRevenueWaterData;
